module.exports = __webpack_public_path__ + "static/img/8.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/8.png
// module id = +ApY
// module chunks = 0